import './styles.scss'

import {
  ApiFixedMultiplier,
  ApiMutualFundAssetRead,
  ApiSegregatedPortfolioAssetRead
} from 'api/rtk-api'
import { LabelValueRow } from 'components/core-v2'
import { sentenceCase } from 'utilities/string'

import { plural } from '../../../../utilities/plural'

export const Details = ({
  asset
}: {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
}) => {
  const showFixedMultiplier = asset.multiplier?.multiplierType === 'Fixed'
  const { cutoffTimeHours, cutoffTimeMinutes } = asset
  const hours = `${cutoffTimeHours} ${plural('hour', cutoffTimeHours)}`
  const minutes = `${cutoffTimeMinutes} ${plural('minute', cutoffTimeMinutes)}`
  const cutOffTime = `${hours} ${minutes}`
  return (
    <>
      <LabelValueRow label="ISIN" showTopBorder={false} value={asset.isinCode} />
      <LabelValueRow label="Name" value={asset.name} />
      <LabelValueRow label="Class" value={asset.assetClass} />
      {showFixedMultiplier && (
        <LabelValueRow
          label="Fixed multiplier"
          value={(asset.multiplier as ApiFixedMultiplier).multiplier}
        />
      )}
      <LabelValueRow label="Notice period" value={asset.noticePeriodDays} />
      <LabelValueRow label="Fund type" value={sentenceCase(asset.type)} />
      <LabelValueRow
        label="Subscription settlement lag"
        value={asset.dealingCalendar.dealingPeriodExpectation.settlementSubscription}
      />
      <LabelValueRow
        label="Redemption settlement lag"
        value={asset.dealingCalendar.dealingPeriodExpectation.settlementRedemption}
      />
      <LabelValueRow label="Currency" value={asset.currencyIso} />
      <LabelValueRow label="Cut off time" value={cutOffTime} />
      <LabelValueRow label="Protection class" value={asset.protectionClassification} />
      <LabelValueRow label="Tax classification" value={asset.taxClassification} />
      <LabelValueRow label="Maximum leverage ratio" value={asset.maxLeverageRatio} />
    </>
  )
}
